<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-12">
        <h5 class="modal-title">Notes</h5>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="clearfix edit-notes-modal-content">
        <div #noteListHolder class="note-list-holder">
          <div
            *ngFor="let note of notes"
            (click)="onEdit(note)"
            class="note-list"
            [class.canEditNote]="canEditNotes"
            [matTooltip]="canEditNotes ? 'Click to edit or delete note' : ''"
            matTooltipClass="text-center"
            matTooltipPosition="left"
          >
            <div [matTooltip]="note.user" matTooltipClass="text-center" matTooltipPosition="above" class="avater">
              <span class="avater-cst-magenta">{{ note.user | initials }}</span>
            </div>
            <div class="content">
              <h4>
                {{ note.user }}
                <small>{{ note.timestamp | epoch }}</small>
              </h4>
              <p>
                {{ note.note }}
              </p>
            </div>
          </div>

          <ng-container *ngIf="notes.length < 1">
            <h5 class="text-center mt15">No notes available</h5>
          </ng-container>
        </div>
        <div class="comment-composer-bottom-fixed">
          <div class="editor-holder">
            <div
              class="comment-composer"
              [class.error-box]="form.get('note').touched && form.get('note').hasError('required')"
            >
              <form [formGroup]="form" [formEditablePermission]="form" class="editor-container">
                <textarea
                  placeholder="Type your notes here..."
                  maxlength="500"
                  class="textarea-editor"
                  formControlName="note"
                  cols="107"
                  rows="5"
                ></textarea>
                <mat-error *ngIf="form.get('note').touched && form.get('note').hasError('required')">
                  Note is <strong>required</strong>
                </mat-error>
                <mat-hint align="end">{{ (form.get('note').value || '').length }}/500</mat-hint>
              </form>
            </div>
            <div class="comment-btns clearfix">
              <ul class="float-right">
                <li>
                  <app-button
                    (click)="save(form)"
                    icon="fal fa-save"
                    [class]="'success' | buttonClass"
                    [loading]="isSavingNote$ | async"
                    [disabled]="1 | isReadonlyRole"
                  >
                    Save
                  </app-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
